module.exports = __webpack_public_path__ + "img/video_4.908d7af4.jpg";